import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'

import { PillSelect, type PillOption } from './PillSelect'
import type { RecordingPreset } from '@/features/yakureki/recording/streaming/recordingPreset'

// 録音モード (生成の深さ) 選択 pill。標準/深掘り。
const MODE_OPTIONS: PillOption<RecordingPreset>[] = [
  {
    value: 'auto',
    label: '標準',
    description: 'AIが自動で判定（推奨）',
  },
  {
    value: 'deep',
    label: '深掘り',
    description: 'AIが過去歴も必ず参照',
  },
]

interface Props {
  value: RecordingPreset
  onChange: (preset: RecordingPreset) => void
  disabled?: boolean
}

export const RecordingModeMenu = ({ value, onChange, disabled }: Props) => (
  <PillSelect
    value={value}
    options={MODE_OPTIONS}
    onChange={onChange}
    ariaLabel="録音モード"
    icon={<AutoAwesomeOutlinedIcon />}
    disabled={disabled}
  />
)
